import React, { useEffect, useRef, useState } from "react";
import AccountSettingSidebar from "../components/AccountSettingSidebar";

import SurveyListHeader from "../../../../component/layout/MainHeader";
import Svg from "../../../../component/Svg";
import Input from "../../../../core/Inputs/DefaultInput";

import CreatableSelect from "react-select/creatable";
import Select from "react-select/creatable";
import SurveyListSidebar from "../../../../component/layout/MainSidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { addTeamMemberSchema, editTeamSchema } from "../../../../schema/team";
import { useDispatch, useSelector } from "react-redux";
import {
  addTeamMember,
  deleteTeamMember,
  editTeam,
  getTeamDetail,
} from "../../../../store/actions/teamAction";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { getUserList } from "../../../../store/actions/userActions";
import { getRoleList } from "../../../../store/actions/roleAction";
import Card from "../../../../core/Card/Card";
import style from "../../../style.module.css";
import NestedMenuToggle from "../NestedMenuToggle";
import {
  countryAllList
} from "../../../../store/actions/locationActions";
const options = [
  { value: "Sam Adams", label: "Sam Adams" },
  { value: "Tim Mayers", label: "Tim Mayers" },
  { value: "John Doe", label: "John Doe" },
];

export default function Edit() {
  const formikRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    teamDataLoading,
    teamData: teamList,
    teamDetail: teamDetail,
    teamMembers: teamMembers,
    totalRecords,
    isAddingTeam,
    isDeleteUser,
  } = useSelector((state) => state.teamData);

  const { countryData } = useSelector(
    (state) => state.locationData
  );

  const { userData } = useSelector((state) => state.userData);
  const { roleData: roleList } = useSelector((state) => state.roleData);

  const [filteredUserList, setFilteredUserList] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const [countries, setCountries] = useState([]);

  const [deleteUserId, setDeleteUserId] = useState(null);

  const fetchTeamDetail = async (teamId) => {
    if (teamDataLoading) return;
    let payload = {
      team_id: teamId,
    };
    dispatch(getTeamDetail(payload));
  };
  const getUsers = async () => {
    console.log("here");
    let payload = { startingLimit: 0, resultsPerPage: 1000, search: "" };
    dispatch(getUserList(payload));
  };

  const getRoles = () => {
    const payload = {
      startingLimit: 0,
      resultsPerPage: 8,
      search: "",
    };
    dispatch(getRoleList(payload));
  };

  const deleteUserData = async () => {
    let payload = { team_member_id: deleteUserId, team_id: location.state.teamId };
    console.log("payload", payload);
    dispatch(deleteTeamMember(payload));
  };


  const getCountryList = async () => {
    dispatch(countryAllList());
  };


  useEffect(() => {
    if (!isDeleteUser) {
      let deleteUser = document.getElementById("deleteTeamMemberModal");
      let deleteUserModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteUser);
      if (deleteUserModal && deleteUserModal._isShown) {
        deleteUserModal.hide();
      }
      fetchTeamDetail(location.state.teamId);
    }
  }, [isDeleteUser]);

  useEffect(() => {
    let teamMemberIds = teamMembers.map((e) => e.user_id);
    let userOptions = userData.map((ele) => {
      return { value: ele.id, label: ele.name };
    });
    setFilteredUserList(
      userOptions.filter((e) => !teamMemberIds.includes(e.value))
    );
  }, [teamMembers]);

  useEffect(() => {
    let teamMemberIds = teamMembers.map((e) => e.user_id);
    let userOptions = userData.map((ele) => {
      return { value: ele.id, label: ele.name };
    });
    setFilteredUserList(
      userOptions.filter(e => !teamMemberIds.includes(e.value) && e.label.trim() !== '')
    );
  }, [userData]);

  useEffect(() => {
    getCountryList();
  }, []);

  useEffect(() => {
    let tempCountries = [];
    Object.keys(countryData).map((ele) => {
      tempCountries.push({
        value: countryData[ele].id,
        label: countryData[ele].name,
      });
      setCountries(tempCountries);
    });
  }, [countryData]);

  useEffect(() => {
    let options = [];
    //console.log("roleList", roleList);

    roleList.map((ele) => {
      options.push({ value: ele.id, label: ele.role_name });
    });
    setRoleOptions(options);
  }, [roleList]);

  useEffect(() => {
    if (location.state && location.state.teamId) {
      fetchTeamDetail(location.state.teamId);
    }
  }, [location]);

  useEffect(() => {
    if (!isAddingTeam) {
      fetchTeamDetail(location.state.teamId);
    }
  }, [isAddingTeam, refresh]);

  useEffect(() => {
    getUsers();
    getRoles();
  }, []);

  const closeModal = () => {
    let addUserModal = document.getElementById("addUserModal");
    let addUserModalInstance = window.bootstrap.Modal.getOrCreateInstance(addUserModal);
    if (addUserModalInstance && addUserModalInstance._isShown) {
      addUserModalInstance.hide();
    }
  };

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/dashboard"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                      <Link to="/admin/settings/user-permissions">
                        User & Teams
                      </Link>
                    </li> */}
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/teams/list">Teams</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Edit team</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Edit team</h1>
                    </div>
                  </div>
                </div>
                <div className="pagesRow varPg">
                  <div className="role-wrapper flex-grow-1">
                    <Formik
                      innerRef={formikRef}
                      initialValues={{
                        team_id:
                          location.state && location.state.teamId
                            ? location.state.teamId
                            : "",
                        team_name: teamDetail && teamDetail.team_name,
                      }}
                      enableReinitialize
                      validationSchema={editTeamSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        let dataToSend = {
                          team_name: values.team_name,
                          team_id: values.team_id,
                        };
                        dispatch(editTeam(dataToSend));
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {({
                        values,
                        errors,
                        handleChange,
                        handleSubmit,
                        resetForm,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="create-team-form pb-3">
                            <label className="form-label-custom">Team name</label>
                            <div className="row gx-12px">
                              <div className="col-lg-6 ">
                                <div className="form-group mb-12px position-relative">
                                  <Input
                                    type="text"
                                    view="outlined"
                                    dense={false}
                                    color="default"
                                    label=""
                                    name="team_name"
                                    placeholder="Team name"
                                    clearButton={true}
                                    success={false}
                                    error={false}
                                    fill={true}
                                    errorHelperText={null}
                                    className={"formsinput"}
                                    defaultValue={values.team_name}
                                    value={values.team_name}
                                    onChange={handleChange}
                                  />
                                  {errors.team_name && (
                                    <div className="validation-msg">
                                      {errors.team_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="button-wrap">
                                  <button type="submit" className="btn btn-primary">
                                    Save
                                  </button>
                                  {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                                  {/* <button type="button" className="btn btn-primary">Save</button> */}

                                </div>
                              </div>
                            </div>

                          </div>
                        </form>
                      )}
                    </Formik>

                    {/* if there are added users */}
                    <div className="col-lg-12">
                      <div className="form-group mb-12px create-team-form">
                        <div className="heading d-flex align-items-center">
                          <div className="flex-grow-1">
                            <h2>Added Members</h2>
                          </div>
                          <div className="button-wrap">
                            {/* <button
                              type="button"
                              className="btn btn-link p-0"
                              data-bs-toggle="modal"
                              data-bs-target="#inviteUserModal"
                              srno="1"
                              value="1"
                            >
                              Invite users
                            </button> */}
                            <button
                              type="button"
                              className="btn btn-link p-0 ms-3"
                              data-bs-toggle="modal"
                              data-bs-target="#addUserModal"
                              srno="1"
                              value="1"
                            >
                              Add users
                            </button>
                          </div>
                        </div>
                        <div className="user-list">
                          {teamMembers.length > 0 &&
                            teamMembers.map((member, memberIndex) => (
                              <div
                                className="list-item d-flex align-items-center"
                                key={memberIndex}
                              >
                                <div className="flex-grow-1 name">
                                  {member.user_name ? member.user_name : "-"}
                                </div>
                                {/* <div className="flex-grow-1 name">
                                  {member.user_id ? member.user_id : "-"}
                                </div> */}
                                <div className="role">
                                  {member.role_name ? member.role_name : "-"}
                                </div>
                                <a
                                  data-bs-toggle="modal"
                                  data-bs-target="#deleteTeamMemberModal"
                                  onClick={() => setDeleteUserId(member.user_id)}
                                  className="action-btn"
                                >
                                  {" "}
                                  <Svg name="table-delete" />{" "}
                                </a>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteTeamMemberModal"
        tabIndex={-1}
        aria-labelledby="deleteTeamMemberModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>Delete users</h3>
                        <p>
                          Are you sure you want to delete these users
                          permanently?{" "}
                        </p>
                      </div>
                      <div className="warning-message">
                        <div className="title d-flex align-items-center">
                          <svg
                            width={40}
                            height={42}
                            viewBox="0 0 40 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2L37.3205 32H2.67949L20 2Z"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 13.5385V22"
                              stroke="#F05454"
                              strokeWidth={3}
                            />
                            <circle
                              cx="19.9994"
                              cy="25.8461"
                              r={1}
                              fill="black"
                              stroke="#F05454"
                              strokeWidth="1.07692"
                            />
                          </svg>
                          <h4>Warning</h4>
                        </div>
                        <p>
                          By deleting the users you will be deleting the users
                          from all the Surveys and their permission to access.
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-cancel"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          onClick={() => deleteUserData()}
                        >
                          Confirm delete
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="inviteUserModal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer"}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-12px" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>Invite member</h4>
                    </div>
                    <form>
                      <div className="create-team-form">
                        <div className="form-group mb-12px position-relative">
                          <label className="form-label-custom">Email</label>
                          <Input
                            type="email"
                            name="email"
                            view="outlined"
                            dense={false}
                            color="default"
                            label=""
                            placeholder="Email"
                            clearButton={true}
                            success={false}
                            error={false}
                            fill={true}
                            errorHelperText={null}
                            className={"formsinput"}

                          // readOnly
                          />
                        </div>

                        <div className="form-group mb-12px cstom-select position-relative">
                          <label className="form-label-custom">Select Role</label>
                          <Select
                            classNamePrefix="select"
                            isClearable
                            options={roleOptions}

                          />
                        </div>

                        <div className="form-group mb-12px cstom-select position-relative">
                          <label className="form-label-custom">Select Country</label>
                          <Select
                            classNamePrefix="select"
                            isClearable
                            options={countries}

                          />
                        </div>



                        <div className="button-wrap d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-bordered color-cancel"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button type="submit" className="btn btn-primary add-btn ms-3">
                            Save
                          </button>
                          {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                          {/* <button type="button" className="btn btn-primary">Save</button> */}

                        </div>
                      </div>
                    </form>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addUserModal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer"}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-12px" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>Add member</h4>
                    </div>

                    <Formik
                      initialValues={{
                        team_id: location.state && location.state.teamId ? location.state.teamId : "",
                        user_id: "",
                        role_id: "",
                        country_id: "",
                      }}
                      enableReiniśtialize={true}
                      validationSchema={addTeamMemberSchema}

                      onSubmit={(values, { setSubmitting, resetForm, setFieldValue }) => {
                        let dataToSend = {
                          team_id: values.team_id,
                          country_id: values.country_id,
                          team_member_id: values.user_id,
                          role_id: values.role_id
                        };
                        // console.log(values);

                        // return
                        // Dispatch action to add team member
                        dispatch(addTeamMember(dataToSend));
                        // Reset form fields


                        //values.country_id = "";
                        // country_id: values.country_id,
                        // team_member_id: values.user_id,
                        // role_id: values.role_id

                        // Close the modal after successful submission
                        //  // Call the closeModal function here

                        resetForm();
                        // setFieldValue("role_id", '');
                        // setSubmitting(false);
                        // fetchTeamDetail(values.team_id);


                        closeModal();
                        setRefresh(true);
                      }}

                    >
                      {({
                        values,
                        errors,
                        resetForm,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          {/* {console.log("errors", errors)} */}


                          <div className="form-group mb-12px cstom-select ">
                            <label className="form-label-custom">Add member</label>
                            <CreatableSelect
                              classNamePrefix="select"
                              isClearable
                              value={
                                filteredUserList
                                  ? filteredUserList.find(
                                    (option) =>
                                      option.value === values.user_id
                                  )
                                  : ""
                              }
                              options={filteredUserList}
                              onChange={(v) => {
                                setFieldValue("user_id", v.value);
                              }}
                            />
                            {errors.user_id && (
                              <div className="validation-msg" style={{ top: '53%' }}>
                                {errors.user_id}
                              </div>
                            )}
                          </div>


                          <div className="form-group mb-12px cstom-select position-relative">
                            <label className="form-label-custom">Select Role</label>
                            <Select
                              classNamePrefix="select"
                              isClearable
                              value={
                                roleOptions
                                  ? roleOptions.find(
                                    (option) =>
                                      option.value === values.role_id
                                  )
                                  : ""
                              }
                              options={roleOptions}
                              onChange={(v) => {
                                setFieldValue("role_id", v.value);
                              }}
                            />
                            {errors.role_id && (
                              <div className="validation-msg" >
                                {errors.role_id}
                              </div>
                            )}
                          </div>


                          <div className="form-group mb-12px cstom-select position-relative">
                            <label className="form-label-custom">Select Country</label>


                            <CreatableSelect
                              value={
                                countries
                                  ? countries.find(
                                    (option) =>
                                      option.value === values.id
                                  )
                                  : ""
                              }
                              placeholder={"Select..."}

                              options={countries}
                              onChange={(e) => {
                                getCountryList(e.value);
                                setFieldValue("country_id", e.value);
                              }}
                            />

                            {errors.country_id && (
                              <div className="validation-msg" >
                                {errors.country_id}
                              </div>
                            )}
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => {
                                resetForm();
                              }}
                              data-bs-dismiss="modal"
                              className="btn btn-bordered color-cancel"
                            >
                              Cancel
                            </button>
                            <button type="submit" className="btn btn-primary ms-3">
                              Save
                            </button>
                            {/* Remove 'disabled' once input fields are filled whihh means the button should look like below once filled*/}
                            {/* <button type="button" className="btn btn-primary">Save</button> */}

                          </div>

                        </form>
                      )}
                    </Formik>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
